// extracted by mini-css-extract-plugin
export var connectorIcon = "whats-new-results-module--connectorIcon--c2411";
export var light = "whats-new-results-module--light--63f20";
export var month = "whats-new-results-module--month--441c6";
export var monthIcon = "whats-new-results-module--monthIcon--104b2";
export var monthText = "whats-new-results-module--monthText--0d7f7";
export var postDivider = "whats-new-results-module--postDivider--4b012";
export var quarterlyRecap = "whats-new-results-module--quarterlyRecap--ed5bf";
export var quarterlyRecapButton = "whats-new-results-module--quarterlyRecapButton--10edf";
export var quarterlyRecapWatchMessage = "whats-new-results-module--quarterlyRecapWatchMessage--ef288";
export var searchResults = "whats-new-results-module--searchResults--bbd2a";
export var video = "whats-new-results-module--video--afadc";